import {defineComponent, useTemplateRef} from 'vue';
import {Button, Popover} from 'primevue';

export default defineComponent({
    name: 'AegSessionStatusPopover',
    components: { Popover, Button },
    setup() {

        const myPopover = useTemplateRef<InstanceType<typeof Popover>>('my-popover');
        return {
            toggle: (event: any) => myPopover.value?.toggle(event),
        };
    }
});
